import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=1260f6ea&scoped=true&"
import script from "./Modal.vue?vue&type=script&lang=js&"
export * from "./Modal.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=1260f6ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1260f6ea",
  null
  
)

export default component.exports